import moment from "moment";
import "moment/locale/id";

export const convertOutletList = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item, index) => {
    converted.push({
      type: "outlet",
      key: index + 1,
      value: item.id,
      label: item.name,
    });
  });
  return converted;
};
